import React from "react";
import removeImg from "assets/svgs/close.svg";
import { v4 } from "uuid";
import { Col, Row } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import ImageUpdate from "./ImageUpdate";
import ImageUpdateValue from "components/shared/ImageUpdateValue";

const SlidersArrayTeam = ({ sliders, setSliders }) => {
  const handleInputOnChange = (e, id) => {
    const { name, value } = e.target;

    const newSlidersArray = sliders?.map((slider) => {
      if (slider.id !== id) return slider;

      // make an object with locals inside the big one
      const inputName = name?.split(".")?.[0];
      const local = name?.split(".")?.[1];

      if (local) {
        return {
          ...slider,
          [inputName]: {
            ...slider?.[inputName],
            [local]: value,
          },
        };
      }

      return { ...slider, [name]: value };
    });

    setSliders(newSlidersArray);
  };

  const removeSlider = (sliderId) => {
    const newSliders = sliders?.filter((slider, index) => index !== sliderId);
    setSliders(() => newSliders);
  };

  const addSlider = () => {
    setSliders(() => [...(sliders || []), { id: v4(), image: "" }]);
  };

  return (
    <div className="form-group branches sliders">
      <Row>
        <Col lg={12}>
          <h5>
            <FormattedMessage id={"team"} />
          </h5>
          <Row>
            {sliders?.map((slider, index) => {
              return (
                <Col lg="6" xs="12" key={slider.id} className=" p-2 h-100">
                  <div className="add-multi-component">
                    <button
                      type="button"
                      onClick={() => removeSlider(index)}
                      className="removeImg"
                    >
                      <img src={removeImg} alt="" />
                    </button>

                    <Row>
                      <Col lg={12} className="text-center">
                        <ImageUpdate
                          index={index}
                          item={slider}
                          sliders={sliders}
                          setSliders={setSliders}
                        />
                      </Col>

                      <Row />
                      <Col lg={6} xs={12}>
                        <div className="form-group">
                          <h5>
                            <FormattedMessage id={"label"} /> ({" "}
                            <FormattedMessage id={"arabic-language"} /> )
                          </h5>
                          <input
                            type="text"
                            name="label.ar"
                            className="form-control form-outline"
                            onChange={(e) => handleInputOnChange(e, slider.id)}
                            value={slider?.label?.ar}
                          />
                        </div>
                      </Col>
                      <Col lg={6} xs={12}>
                        <div className="form-group">
                          <h5>
                            <FormattedMessage id={"label"} /> ({" "}
                            <FormattedMessage id={"english-language"} /> )
                          </h5>
                          <input
                            type="text"
                            name="label.en"
                            className="form-control form-outline"
                            onChange={(e) => handleInputOnChange(e, slider.id)}
                            value={slider?.label?.en}
                          />
                        </div>
                      </Col>
                      <Col lg={6} xs={12}>
                        <div className="form-group">
                          <h5>
                            <FormattedMessage id={"description"} /> ({" "}
                            <FormattedMessage id={"arabic-language"} /> )
                          </h5>
                          <textarea
                            type="text"
                            name="description.ar"
                            className="form-control form-outline"
                            onChange={(e) => handleInputOnChange(e, slider.id)}
                            value={slider?.description?.ar}
                          />
                        </div>
                      </Col>
                      <Col lg={6} xs={12}>
                        <div className="form-group">
                          <h5>
                            <FormattedMessage id={"description"} /> ({" "}
                            <FormattedMessage id={"english-language"} /> )
                          </h5>
                          <textarea
                            type="text"
                            name="description.en"
                            className="form-control form-outline"
                            onChange={(e) => handleInputOnChange(e, slider.id)}
                            value={slider?.description?.en}
                          />
                        </div>
                      </Col>
                    </Row>
                    <hr />
                    <Row>
                      <Col xs={9}>
                        <div className="form-group">
                          <h5>
                            <FormattedMessage id={"socialLink"} /> 1
                          </h5>
                          <input
                            type="text"
                            name="socialLink1"
                            className="form-control form-outline"
                            onChange={(e) => handleInputOnChange(e, slider.id)}
                            value={slider?.socialLink1}
                          />
                        </div>
                      </Col>
                      <Col xs={3}>
                        <ImageUpdateValue
                          title="icon"
                          style={{ width: "100%", height: "50px" }}
                          value={slider?.socialLink1Image}
                          setValue={(value) =>
                            handleInputOnChange(
                              { target: { name: "socialLink1Image", value } },
                              slider.id
                            )
                          }
                        />
                      </Col>
                      <Col xs={9}>
                        <div className="form-group">
                          <h5>
                            <FormattedMessage id={"socialLink"} /> 2
                          </h5>
                          <input
                            type="text"
                            name="socialLink2"
                            className="form-control form-outline"
                            onChange={(e) => handleInputOnChange(e, slider.id)}
                            value={slider?.socialLink2}
                          />
                        </div>
                      </Col>
                      <Col xs={3}>
                        <ImageUpdateValue
                          title="icon"
                          style={{ width: "100%", height: "50px" }}
                          value={slider?.socialLink2Image}
                          setValue={(value) =>
                            handleInputOnChange(
                              { target: { name: "socialLink2Image", value } },
                              slider.id
                            )
                          }
                        />
                      </Col>
                      <Col xs={9}>
                        <div className="form-group">
                          <h5>
                            <FormattedMessage id={"socialLink"} /> 3
                          </h5>
                          <input
                            type="text"
                            name="socialLink3"
                            className="form-control form-outline"
                            onChange={(e) => handleInputOnChange(e, slider.id)}
                            value={slider?.socialLink3}
                          />
                        </div>
                      </Col>
                      <Col xs={3}>
                        <ImageUpdateValue
                          title="icon"
                          style={{ width: "100%", height: "50px" }}
                          value={slider?.socialLink3Image}
                          setValue={(value) =>
                            handleInputOnChange(
                              { target: { name: "socialLink3Image", value } },
                              slider.id
                            )
                          }
                        />
                      </Col>
                    </Row>
                  </div>
                </Col>
              );
            })}
          </Row>
        </Col>

        <Col lg={4} xs={12} className="text-left">
          <button
            type="button"
            className="btn btn-green add_new_section__"
            onClick={() => {
              addSlider();
            }}
          >
            <FormattedMessage id={"addSlider"} />
          </button>
        </Col>
      </Row>
    </div>
  );
};

export default SlidersArrayTeam;
